module.exports = __webpack_public_path__ + "front/img/bg01.d42cfd7a.png";